// import React from "react";

// import Header from "../components/Header";
// import Footer from "../components/Footer";

// import SubjectCard from "../components/SubjectCard";
// import resourcesData from "../data/resourcesData";

// import "../css/EResources.css";

// function EResources() {
//     return (
//         <div className="eresources-container">
//             {/* Header and Navigation */}
//             <Header />
//             {/* E-Resources Content */}
//             <div className="eresources-body">
//                 {/* Page Heading */}
//                 <div className="eresources-title">
//                     <h1>E - Resources</h1>
//                </div>

//                 {/* Subject Cards */}
//                 <div className="subjects-container">
//                     {resourcesData.map((subject) => (
//                         <SubjectCard
//                             key={subject.id}
//                             subject={subject}
//                         />
//                     ))}
//                 </div>
//             </div>
//             {/* Footer */}
//             <Footer />
//         </div>
//     );
// }


// export default EResources;

import React, { useState } from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";

import SubjectCard from "../components/SubjectCard";
import resourcesData from "../data/resourcesData";

import "../css/EResources.css";

function EResources() {

    // Get unique academic years
    const academicYears = [
        ...new Set(
            resourcesData.map((subject) => subject.academicYear)
        )
    ];

    // Automatically select the first academic year
    const [selectedYear, setSelectedYear] = useState(
        academicYears[0] || null
    );

    // Get subjects for selected academic year
    const filteredSubjects = selectedYear
        ? resourcesData.filter(
              (subject) =>
                  subject.academicYear === selectedYear
          )
        : [];

    return (
        <div className="eresources-container">

            {/* Header and Navigation */}
            <Header />


            {/* E-Resources Content */}
            <div className="eresources-body">

                {/* Page Heading */}
                <div className="eresources-title">
                    <h1>E - Resources Hub</h1>
                </div>

                <div className="eresources-description">
                    <p>
                        Access quality academic resources organized by academic year
                        for easy and convenient learning. This E-Resources portal
                        provides students with subject-wise PPTs, lecture notes,
                        and other learning materials in one place. Select your
                        academic year below to explore the available resources
                        and enhance your learning experience.
                    </p>
                </div>


                {/* Academic Year Links */}
                <div className="academic-years">

                    <h2>
                        Select Academic Year
                    </h2>

                    <div className="year-links">

                        {academicYears.map((year) => (

                            <button
                                key={year}
                                className={`year-link ${
                                    selectedYear === year
                                        ? "active"
                                        : ""
                                }`}
                                onClick={() =>
                                    setSelectedYear(year)
                                }
                            >
                                {year}
                            </button>

                        ))}

                    </div>

                </div>


                {/* Subjects for Selected Year */}
                {selectedYear && (

                    <div className="year-subjects">

                        <h2>
                            {selectedYear} - Subjects
                        </h2>


                        <div className="subjects-container">

                            {filteredSubjects.length > 0 ? (

                                filteredSubjects.map(
                                    (subject) => (

                                        <SubjectCard
                                            key={subject.id}
                                            subject={subject}
                                        />

                                    )
                                )

                            ) : (

                                <p>
                                    No subjects available for{" "}
                                    {selectedYear}.
                                </p>

                            )}

                        </div>

                    </div>

                )}

            </div>


            {/* Footer */}
            <Footer />

        </div>
    );
}

export default EResources;